/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use object file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var $ = require('jquery');

/**
 * 提供URL相关的工具类函数.
 *
 * @param url
 *                路径.
 */
module.exports = function (url) {
	var object = {};
	object.p = {};

	if (!url)
		url = location.search;

	var index = url.indexOf('?');

	object.base_url = index > -1 ? url.substring(0, index) : url;
	url = index > -1 ? url.substring(index) : url;

	var reg = /(?:^\?|&)(.*?)=(.*?)(?=&|$)/g,
	temp;
	while ((temp = reg.exec(url)) != null)
		object.p[decodeURIComponent(temp[1])] = decodeURIComponent(temp[2]);

	object.set = function (name, value) {
		object.p[name] = value;
		return object;
	};

	object.get = function (name, def) {
		var v = object.p[name];
		return (v != null) ? v : def;
	};

	object.has = function (name) {
		return object.p[name] != null;
	};

	object.toStr = function () {
		var r = '?';
		for (var k in object.p)
			r += encodeURIComponent(k) + '=' + encodeURIComponent(object.p[k]) + '&';
		return r;
	};

	object.param = function () {
		return $.param(object.p);
	}

	return object;
}



/*****************
 ** WEBPACK FOOTER
 ** ./lib/urlparser.js
 ** module id = 109
 ** module chunks = 4
 **/